if (!window.RC) { window.RC = {}; }
window.RC.CheckoutAdmin = (function($) {
  function init() {
    $(document).on('gform_post_render', renderCheckoutStatus);
  }

  function updateStatus(entryId, nonce, status) {
    const params = {
        action: 'pt-chk-update-status',
        'pt-chk-eid': entryId,
        'pt-chk-nonce': nonce,
        'pt-chk-status': status
      };

    $('#checkoutUpdateSpinner').show();
    const responseHandler = buildResponseHandler('status');

    $.ajax({
      type: "POST",
      url: admin_ajax.ajax_url,
      data: params,
      success: responseHandler,
      error: responseHandler
    });
  }
  
  function regeneratePreload($entryId, $nonce) {
    $('#checkoutRegenSpinner').show();

    const params = {
      action: 'pt-chk-regen-preload',
      'pt-chk-eid': $entryId,
      'pt-chk-nonce': $nonce
    };
      
    const responseHandler = buildResponseHandler('regen', (response) => {
      const submissionFormEl = document.querySelector('#monerisCheckout');
      
      if (submissionFormEl) {
        submissionFormEl.dataset.monerisTicket = response.data.ticketId;
      }
    });
    
    $.ajax({
      type: "POST",
      url: admin_ajax.ajax_url,
      data: params,
      success: responseHandler,
      error: responseHandler
    });
  }
  
  function buildResponseHandler(source, successCallback = null, errorCallback = null) { 
    return function(response, status, jsXhr) {
      let spinner, statusSelector, successMsg;
      
      switch (source) {
        case 'regen':
          spinner = '#checkoutRegenSpinner';
          statusSelector = '#checkoutRegenStatus';
          successMsg = 'Regenerated!';
          break;
          
        case 'receipt':
          spinner = '#checkoutReceiptSpinner';
          statusSelector = null;
          break;
          
        default:
          spinner = '#checkoutUpdateSpinner';
          statusSelector = '#checkoutUpdateStatus';
          successMsg = 'Updated!';
          break;
      }        
      
      $(spinner).hide();
  
      if (status == 'success' && response.success === true) {
        $(statusSelector).show().text(successMsg);
        successCallback && successCallback(response);
      }
      else {
        $(statusSelector).show().text('Error');
        errorCallback && errorCallback(response);
      }
  
      setTimeout(function() { $(statusSelector).fadeOut(); }, 2000);
    };
  }
  
  /**
   * Called when a user clicks the Payment button.  Opens the Moneris checkout and
   * handles the response callbacks.
   */
  function initiatePayment(mode) {
    const checkout = new monerisCheckout();
    checkout.setMode(mode);
    checkout.setCheckoutDiv('monerisCheckout');
    
    const refreshCallback = function() {
      checkout.closeCheckout();
      renderCheckoutStatus(true);
    }

    checkout.setCallback("cancel_transaction", refreshCallback);
    checkout.setCallback("error_event", refreshCallback);
    checkout.setCallback("payment_receipt", refreshCallback);
    checkout.setCallback("payment_complete", refreshCallback);
    checkout.setCallback("page_closed", refreshCallback);

    const submissionFormEl = document.querySelector('#monerisCheckout');
    const ticket = submissionFormEl.dataset.monerisTicket;
    checkout.startCheckout(ticket);
  }
  
  function renderCheckoutStatus(showTxResult = false) {
    const resultBox = document.getElementById('monerisCheckoutStatus__result');
    resultBox && resultBox.classList.remove('monerisCheckoutStatus__result--hasResult');
    
    const checkoutEl = document.getElementById('monerisCheckoutStatus') || document.querySelector('.gform-confirmation-payment-form');
    if (!checkoutEl) { return; }
    
    checkoutEl.classList.remove('monerisCheckoutStatus--hasStatus');

    const params = {
      action: 'pt-chk-fetch-status',
      'pt-chk-eid': checkoutEl.dataset.entryId,
      'pt-chk-oid': checkoutEl.dataset.orderId,
    };

    const responseHandler = (response, status, jsXhr) => {
      if (status !== 'success' || !response || response.success !== true || !response.data) {
        console.error("Error retrieving order status: ", response, status);
        return;
      }
      
      const data = response.data;
      const orderStatus = data.orderStatus;
      const isApproved = (data.lastTxResult === 'a');
      const isUnknownStatus = (orderStatus === 'Unknown');
      const approvalLabel = window.ptMonerisStatusLabels[(isApproved) ? 'approved' : 'declined' ];
      let statusLabel = window.ptMonerisStatusLabels[orderStatus];
      
      if (showTxResult && data.lastTxResult) {
        statusLabel += ` (${ approvalLabel })`;
       
        if (resultBox) {
          const resultTextEl = resultBox.querySelector('.monerisCheckoutStatus__resultText');
          resultBox.classList.add('monerisCheckoutStatus__result--hasResult');
          resultBox.classList.remove('monerisCheckoutStatus__result--approved');
          resultBox.classList.remove('monerisCheckoutStatus__result--declined');
          resultBox.classList.add(`monerisCheckoutStatus__result--${ isApproved ? 'approved' : 'declined' }`);
          
          if (isUnknownStatus) {
            resultTextEl.innerText = "An error occurred confirming your payment.  Please check the status page again in a few minutes or contact an administrator.";
          }
          else {
            resultTextEl.innerText = approvalLabel;
          }
        } 
      }

      checkoutEl.classList.add('monerisCheckoutStatus--hasStatus');
      checkoutEl.classList.toggle('monerisCheckoutStatus--paid', orderStatus === 'Paid');
      
      const statusMsgEl = checkoutEl.querySelector('#orderDetails__monerisCheckoutStatusMsg');
      statusMsgEl && (statusMsgEl.innerText = statusLabel);

      const submissionFormEl = checkoutEl.querySelector('#monerisCheckout');
      submissionFormEl && (submissionFormEl.dataset.monerisTicket = data.ticketId); 
    };
    
    $.ajax({
      type: "POST",
      url: admin_ajax.ajax_url,
      data: params,
      success: responseHandler,
      error: responseHandler
    });
  }
  
  $(init);
  
  return {
    updateStatus, regeneratePreload, initiatePayment, renderCheckoutStatus
  }
})(jQuery);
